import type { ClientBillingExternalPostFormEntity } from '@/entities/client-billing.entity';

export type ReservedExternalPostTarget = {
    name: string;
    windowRef: Window;
};

export const reserveExternalPostTarget = (targetPrefix: string): ReservedExternalPostTarget | null => {
    const name = `${targetPrefix}-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
    const windowRef = window.open('', name);

    if (!windowRef) {
        return null;
    }

    windowRef.opener = null;

    return {
        name,
        windowRef,
    };
};

export const closeReservedExternalPostTarget = (target: ReservedExternalPostTarget): void => {
    target.windowRef.close();
};

export const submitExternalPostFormToTarget = (
    form: ClientBillingExternalPostFormEntity,
    target: ReservedExternalPostTarget,
): void => {
    const formElement = document.createElement('form');
    formElement.method = form.method;
    formElement.action = form.action;
    formElement.target = target.name;
    formElement.style.display = 'none';

    for (const [name, value] of Object.entries(form.fields)) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        formElement.append(input);
    }

    document.body.append(formElement);
    formElement.submit();
    formElement.remove();
};
